import * as ApiConfig from "../api/api-config";
import Cookies from "universal-cookie";
export function ConvertStringToNumberArray(stringData) {
    const result = [];
    stringData.split(',').map((dataNumber) => result.push(Number(dataNumber)))
    return result
}
// Bỏ dấu tiếng Việt và chuyển thành slug: "Khu công nghiệp" -> "khu-cong-nghiep"
export const toSlug = (text = "") =>
    (text || "")
        .normalize("NFD")
        .replace(/[̀-ͯ]/g, "")
        .replace(/đ/g, "d")
        .replace(/Đ/g, "D")
        .toLowerCase()
        .trim()
        .replace(/[^a-z0-9\s-]/g, "")
        .replace(/[\s-]+/g, "-")
        .replace(/^-+|-+$/g, "");

// URL hiển thị file từ filePreview (dạng Files backend trả về, có thể chứa "\")
export const getFileUrl = (filePreview) => {
    if (!filePreview) return "";
    const path = filePreview.replace(/\\/g, "/").replace(/^\/+/, "");
    return ApiConfig.api.replace(/\/+$/, "") + "/" + path;
};

// Lấy thông báo lỗi từ các dạng lỗi backend trả về (nghiệp vụ, validate model ASP.NET, 404)
export const getInvestmentErrorMessage = (err) => {
    if (!err) return "Có lỗi xảy ra.";
    if (err.errorMessage && err.errorMessage !== "UnhandleException") return err.errorMessage;
    if (err.errors) {
        const first = Object.values(err.errors)[0];
        return (first && first[0]) || "Dữ liệu không hợp lệ.";
    }
    if (err.status === 404) return "Không tìm thấy dữ liệu.";
    return "Có lỗi xảy ra.";
};

export function GenerateDeviceId() {
    const cookies = new Cookies();
    var uid = cookies.get("DeviceId");
    if(uid == null)
    {
        const expireTime = new Date();
        const domainName = ApiConfig.domainName;
        expireTime.setTime(expireTime.getTime() + 30 *24 * 60 * 60 * 1000);

        let options = { path: "/", domain: domainName, expires: expireTime };
        cookies.set("DeviceId", uniqueID(), options);
        //localStorage.setItem("DeviceId",uniqueID());
        return uniqueID();
    }
    else
    {
        return uid;
    }
    function uniqueID(){
        function chr4(){
          return Math.random().toString(16).slice(-4);
        }
        return chr4() + chr4() +
          '-' + chr4() +
          '-' + chr4() +
          '-' + chr4() +
          '-' + chr4() + chr4() + chr4();
      }
}
